import React, { forwardRef } from 'react';

import { AlineTooltip } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

import ActImg from './act.png';
import ActiveCampaignImg from './activecampaign.png';
import CloseImg from './close.png';
import CopperImg from './copper.png';
import HubSpotImg from './hubspot.png';
import MicrosoftDynamicsImg from './microsoft-dynamics.png';
import PipeDriveImg from './pipedrive.png';
import SalesflareImg from './salesflare.png';
import SalesForceImg from './salesforce.png';
import TeamleaderImg from './teamleader.jpg';
import ZendeskSellImg from './zendesk-sell.png';
import ZohoCrmImg from './zohocrm.png';

interface CrmIntegrationIconProps {
  integration: Apollo.Integration;
  className?: string;
}

export const CrmIntegrationIcon = forwardRef(function CrmIntegrationIcon(
  { className, integration }: CrmIntegrationIconProps,
  ref: React.Ref<HTMLImageElement>
): JSX.Element {
  switch (integration) {
    case Apollo.Integration.Act:
      return <img ref={ref} className={className} src={ActImg} />;
    case Apollo.Integration.ActiveCampaign:
      return <img ref={ref} className={className} src={ActiveCampaignImg} />;
    case Apollo.Integration.Close:
      return <img ref={ref} className={className} src={CloseImg} />;
    case Apollo.Integration.Copper:
      return <img ref={ref} className={className} src={CopperImg} />;
    case Apollo.Integration.HubSpot:
      return <img ref={ref} className={className} src={HubSpotImg} />;
    case Apollo.Integration.MicrosoftDynamics:
      return <img ref={ref} className={className} src={MicrosoftDynamicsImg} />;
    case Apollo.Integration.Pipedrive:
      return <img ref={ref} className={className} src={PipeDriveImg} />;
    case Apollo.Integration.SalesForce:
      return <img ref={ref} className={className} src={SalesForceImg} />;
    case Apollo.Integration.Salesflare:
      return <img ref={ref} className={className} src={SalesflareImg} />;
    case Apollo.Integration.Teamleader:
      return <img ref={ref} className={className} src={TeamleaderImg} />;
    case Apollo.Integration.ZendeskSell:
      return <img ref={ref} className={className} src={ZendeskSellImg} />;
    case Apollo.Integration.ZohoCrm:
      return <img ref={ref} className={className} src={ZohoCrmImg} />;
  }
});

const useStyles = makeStyles()(_theme => ({
  img: {
    height: 24,
    width: 24,
  },
  tooltip: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const CrmIntegrationIcon24By24 = forwardRef(function CrmIntegrationIcon24By24(
  { integration }: CrmIntegrationIconProps,
  ref: React.Ref<HTMLImageElement>
): JSX.Element {
  const { classes } = useStyles();
  return <CrmIntegrationIcon ref={ref} className={classes.img} integration={integration} />;
});

interface CrmIntegrationIconWithTooltipProps extends CrmIntegrationIconProps {
  attributePath: string;
  title?: string;
}

export function CrmIntegrationIconWithTooltip({
  integration,
  title = `Variable connected to ${integration}`,
}: CrmIntegrationIconWithTooltipProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <AlineTooltip arrow className={classes.tooltip} placement="top" title={title}>
      <div>
        <CrmIntegrationIcon24By24 integration={integration} />
      </div>
    </AlineTooltip>
  );
}
